import React, { useState, useEffect, useReducer } from "react";
import "../Style.css";
import "../Responsive.css";
import "../bootstrap.min.css";
import { Box, Container, Stack } from "@mui/system";
import Utils from "../core/Utils";
import UserHelper from "../core/UserHelper";
import {
    BelowThresholdPage,
    LoginPage,
    OrderDetailsPage,
    PurchaseOrderPage,
} from "../core/PageConstants";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@mui/material";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import { SideBarMenuNames } from "../core/Constants";
import { OverviewPage } from "../core/PageConstants";
import "../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useDispatch } from "react-redux";
import { getCountry } from "../data/localSettingsActions";
import { connectToStore } from "../data/store";
import { postAsync } from "../core/serviceClient";
import CartComponent from "./common/CartComponent";
import {
    getServiceItemFromProduct,
    convertServiceItemObject,
} from "../helpers/productHelper";
import { serviceItemReducer } from "./reducers/serviceItem/serviceItemReducer";
import { serviceItemActionTypes } from "./reducers/serviceItem/serviceItemActionTypes";
import CustomAddProductSelection from "./common/CustomAddProductSelection";

const PurchaseOrder = () => {
    document.title = "Purchase Order";
    var pageTitle = "Purchase Order";
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [isSelectedProduct, setIsSelectedProduct] = useState(false);
    const [localSettings, setLocalSettings] = useState({});
    const [selectedVendor, setSelectedVendor] = useState("");
    const [totalPrice, setTotalPrice] = useState(0);
    const [countryInfo, setCountryInfo] = useState({});
    const [filteredServiceItems, itemDispatch] = useReducer(
        serviceItemReducer,
        []
    );
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const setAlert = (msg) => {
        setAlertMessage(msg);
        setShowAlert(true);
    };
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState({});
    const [isOpenAddProductSelection, setIsOpenAddProductSelection] = useState(false);
    const [fetchedProducts,setFetchedProducts] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [overallCategoryList,setOverallCategoryList] = useState([]);
    const [overallTypeList, setOverallTypeList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [filterFetchedProducts, setFilterFetchedProducts] = useState([]);

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(PurchaseOrderPage, navigate)) {
            setLocalSettings(localSetting);
            setCountryInfo(getCountry());
            if (!Utils.IsNullOrEmptyArray(location.state)) {
                let serviceItems = "";
                let product = "";
                if (location.state.isFromOrderDetailsPage) {
                    var orderDetails = location.state.selectedOrder;
                    setSelectedOrder(orderDetails);
                    product = orderDetails.serviceItems;
                    serviceItems = product.map((product) => getServiceItemObj(product));
                    serviceItems.forEach((item) => {
                        if (
                            Utils.IsNullOrEmptyObject(
                                filteredServiceItems.find((s) => s.ProductId === item.ProductId)
                            )
                        )
                            itemDispatch({
                                type: serviceItemActionTypes.Add,
                                value: item,
                            });
                    });
                    setSelectedProducts(serviceItems);
                    setSelectedVendor(orderDetails.vendorDetails);
                } else if (location.state.isCreateNewOrder) {
                    setSelectedVendor(location.state.SelectedVendor);
                } else {
                    product = location.state.SelectedProduct;
                    serviceItems = product.map((product) =>
                        getServiceItemFromProduct(product)
                    );
                    serviceItems.forEach((item) => {
                        if (
                            Utils.IsNullOrEmptyObject(
                                filteredServiceItems.find((s) => s.ProductId === item.ProductId)
                            )
                        )
                            itemDispatch({
                                type: serviceItemActionTypes.Add,
                                value: item,
                            });
                    });
                    setSelectedProducts(serviceItems);
                    setSelectedVendor(location.state.SelectedVendor);
                }
            }
        }
    }, []);
    const getServiceItemObj = (item) => {
        return convertServiceItemObject(item, true);
    };
    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const backNavigation = () => {
        if (location.state.isFromOrderDetailsPage) {
            navigate(OrderDetailsPage.Path, {});
        } else {
            navigate(BelowThresholdPage.Path, {});
        }
    };
    const addItemToCart = (product, isCustomProduct = false,sequenceValue=0) => {
        if (
            !Utils.IsNullOrEmptyObject(
                filteredServiceItems.find((s) => s.ProductId === product.id)
            )
        ) {
            setAlert("Product already added");
            return;
        }
        var serviceItem = isCustomProduct
            ? product
            : getServiceItemFromProduct(product);
        serviceItem.reviewProduct = product.reviewProduct;
        serviceItem.imageUrl = product.imageUrl;
        if (Utils.IsNullOrEmptyArray(filteredServiceItems)) {
            serviceItem.Sequence = 1;
        } else {
            serviceItem.Sequence =
                filteredServiceItems[filteredServiceItems.length - 1].Sequence + 1;
        }
        if(sequenceValue) {
          serviceItem.Sequence = sequenceValue;
        }
        itemDispatch({
            type: serviceItemActionTypes.Add,
            value: serviceItem,
        });
        configureDialog();
    };
    const handleServiceItemActions = (action) => {
        if (
            action.type === serviceItemActionTypes.Clear ||
            (filteredServiceItems.length === 1 &&
                action.type === serviceItemActionTypes.Delete)
        ) {
            setShowDialog(false);
        }
        itemDispatch(action);
    };
    const configureDialog = () => {
        if (!showDialog) {
            setShowDialog(true);
        }
    };
    const clickCreateOrder = async () => {
        if (filteredServiceItems.length === 0) {
            setAlert("Please add items to place a purchase order.");
            return;
        }
        var request = {
            Id: !Utils.IsNullOrEmptyArray(selectedOrder) ? selectedOrder.id : "",
            BusinessId: localSettings.business.businessId,
            BranchId: localSettings.branch.branchId,
            ServiceItems: filteredServiceItems,
            Status: "Requested",
            BranchName: localSettings.branch.branchName,
            UserId: localSettings.user.id,
            Username: localSettings.user.userName,
            ExpecetedDT: "",
            ReferralCode: localSettings.business.referralCode,
            OrderDesc: `${filteredServiceItems[0].Description}${filteredServiceItems.length > 1
                ? ` +${filteredServiceItems.length - 1}`
                : ""
                }`,
            VendorDetails: selectedVendor,
        };
        var result = await postAsync(
            "PurchaseOrder/CreatePurchaseOrderForBusiness",
            request
        );
        setIsLoading(false);
        if (result.error) {
            setIsNavigateToLogin(result.isNavigateToLogin);
            setAlert(result.errorMessage);
            return;
        } else {
            setShowSuccessDialog(true);
        }
    };

    const handleCloseDialog = () => {
        setShowSuccessDialog(false);
        if (location.state.isFromOrderDetailsPage) {
            navigate(OrderDetailsPage.Path, {});
        } else {
            navigate(OverviewPage.Path);
        }
    };

    function getVendorFullAddress(vendor) {
        if (!vendor) return "";

        if (Utils.IsNullOrEmpty(vendor.vendorAddress)) {
            const parts = [
                vendor.vendorCustomAddress,
                vendor.vendorCustomCity,
                vendor.vendorCustomState,
                vendor.vendorCustomPinCode,
            ].filter(Boolean);

            return parts.join(", ");
        }

        return vendor.vendorAddress;
    }

    const OpenProductSelection = () => {
        const filteredIds = new Set(filteredServiceItems.map(x => x.ProductId));
        const filterProducts = fetchedProducts.filter(
            (p) => !filteredIds.has(p.id)
        );
        setFilterFetchedProducts(filterProducts)
        setSelectedIds(filteredServiceItems.map(item => item.ProductId))
        setIsOpenAddProductSelection(true);
        setVisibleProducts(filterProducts.slice(0,1000));
      }
      const CloseProductSelection = () => {
        setIsOpenAddProductSelection(false);
      }
      const handleAddSelectedProducts = (selectedProductsIds) => {
      if (!Utils.IsNullOrEmptyArray(selectedProductsIds)) {
        const filteredItemIds = new Set(filteredServiceItems.map(item => item.ProductId));
        const filteredSelectProductIds = new Set(
            [...selectedProductsIds].filter(id => !filteredItemIds.has(id))
        );

        let sequenceIndex = filteredServiceItems.length;
        if(!Utils.IsNullOrEmptyArray(filteredServiceItems)) {
            sequenceIndex = filteredServiceItems[sequenceIndex-1].Sequence
        }
    
        fetchedProducts.forEach((p) => {
          if (filteredSelectProductIds.size && filteredSelectProductIds.has(p.id)) {
            addItemToCart(p,false,++sequenceIndex);
        } 
        });
      }
    };

    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <MessagePopup
                    msgOpen={showAlert}
                    msgText={alertMessage}
                    onMsgClose={() => setShowAlert(false)}
                />
                <Dialog
                    open={showSuccessDialog}
                    onClose={() => setShowSuccessDialog(false)}
                >
                    <DialogTitle variant="h6" gutterBottom>
                        {" "}
                        Success
                    </DialogTitle>
                    <DialogContent variant="h5" gutterBottom>
                        Order is created successfully.
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                handleCloseDialog();
                            }}
                            autoFocus
                            className="btn btn-primary white-text"
                            variant="contained"
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid
                            xs={12}
                            className="content-sec"
                            sx={{ "padding-bottom": "100px" }}
                        >
                            <Grid container direction="row" className="">
                                <Grid
                                    container
                                    className="title-sec"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography
                                        level="h2"
                                        component="h2"
                                        fontWeight="600"
                                        fontSize="2rem"
                                        className="page-title text-center"
                                    >
                                        <Button onClick={backNavigation} className="back-btn">
                                            <NavigateBeforeIcon fontSize="large" />
                                        </Button>
                                        {pageTitle}
                                    </Typography>
                                </Grid>

                                <Grid
                                    container
                                    xs={12}
                                    className="font-size-14 data-grid-box"
                                    spacing={2}
                                >
                                    {selectedVendor && (
                                        <Grid item xs={12}>
                                            <Card sx={{ p: 2 }}>
                                                <Typography variant="h6">
                                                    <strong>Vendor:</strong> {selectedVendor.vendorName}
                                                </Typography>
                                                <Typography>
                                                    <strong>Contact:</strong> {selectedVendor.vendorContact}
                                                </Typography>
                                                <Typography>
                                                    <strong>Address:</strong> {getVendorFullAddress(selectedVendor)}
                                                </Typography>
                                            </Card>
                                        </Grid>
                                    )}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            position: "relative",
                                            marginTop: "1%",
                                        }}
                                    >
                                        <Card sx={{ p: 2 }} style={{ overflow: "inherit" }}>
                                            <CartComponent
                                                serviceItems={filteredServiceItems}
                                                onAddItem={addItemToCart}
                                                handleItemAction={handleServiceItemActions}
                                                includePreview={true}
                                                onChangeTotal={setTotalPrice}
                                                isFromPurchaseOrder={true}
                                                setFetchedProducts={setFetchedProducts}
                                                OpenProductSelection={OpenProductSelection}
                                                setOverallCategoryList={setOverallCategoryList}
                                                setOverallTypeList={setOverallTypeList}
                                                setTypeList={setTypeList}
                                            />

                                            <Stack className="text-right px-1">
                                                <Typography
                                                    level="h4"
                                                    component="h4"
                                                    className="my-1"
                                                    fontWeight="600"
                                                    fontSize="20px"
                                                >
                                                    <small>Total:</small> &nbsp;
                                                    {Utils.GetCurrency(totalPrice, countryInfo)}
                                                </Typography>
                                            </Stack>
                                        </Card>
                                    </Grid>

                                    <Grid flex="1" spacing={2} className="mt-2 fixed-btn">
                                        <Grid className="container">
                                            <Grid container xs={12}>
                                                <Grid xs={1} alignSelf="center"></Grid>
                                                <Grid xs={9} className=""></Grid>
                                                <Grid
                                                    xs={12}
                                                    lg={0}
                                                    className="text-right"
                                                    sx={{ display: "flex", justifyContent: "end" }}
                                                >
                                                    <Button
                                                        className="btn btn-primary align-self-start"
                                                        variant="contained"
                                                        onClick={clickCreateOrder}
                                                    >
                                                        {location.state.isFromOrderDetailsPage === true
                                                            ? "Update"
                                                            : "Create Order"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <CustomAddProductSelection
                            open={isOpenAddProductSelection}
                            overAllproducts={filterFetchedProducts}
                            limit={1000}
                            onCloseProductSelection={CloseProductSelection}
                            visibleProducts={visibleProducts}
                            setVisibleProducts={setVisibleProducts}
                            categoryList = {overallCategoryList}
                            typeList ={typeList}
                            setTypeList={setTypeList}
                            overAllTypeList = {overallTypeList}
                            handleAddSelectedProducts = {handleAddSelectedProducts}
                            selectedIds = {selectedIds}
                        />
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};
export default PurchaseOrder;
